import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "polling", data: null });
  const timer = useRef(null);
  const attempts = useRef(0);
  const navigate = useNavigate();
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { setState({ status: "error", data: null }); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState({ status: "paid", data }); return; }
        if (["failed", "expired", "cancelled"].includes(data.payment_status)) { setState({ status: "failed", data }); return; }
        attempts.current += 1;
        if (attempts.current > 15) { setState({ status: "timeout", data }); return; }
        timer.current = setTimeout(poll, 2000);
      } catch { setState({ status: "error", data: null }); }
    };
    poll();
    return () => timer.current && clearTimeout(timer.current);
  }, [sid]);

  return (
    <div className="min-h-screen bg-zinc-950 grid place-items-center px-6" data-testid="payment-success">
      <div className="max-w-md w-full rounded-xl border border-zinc-800 bg-zinc-900/40 p-8 text-center">
        {state.status === "polling" && (<><Loader2 className="w-10 h-10 mx-auto animate-spin text-zinc-300" /><h2 className="mt-4 font-display text-xl text-zinc-100">Confirming payment…</h2></>)}
        {state.status === "paid" && (<><CheckCircle2 className="w-10 h-10 mx-auto text-emerald-500" /><h2 className="mt-4 font-display text-xl text-zinc-100">Payment successful</h2><p className="mt-2 text-sm text-zinc-500">Your subscription is now active.</p></>)}
        {(state.status === "failed" || state.status === "error" || state.status === "timeout") && (<><XCircle className="w-10 h-10 mx-auto text-rose-500" /><h2 className="mt-4 font-display text-xl text-zinc-100">Payment issue</h2><p className="mt-2 text-sm text-zinc-500">We could not confirm the payment. Please retry or contact support.</p></>)}
        <button onClick={() => navigate("/app")} className="btn-scale mt-6 h-9 px-4 rounded-md bg-white text-zinc-950 text-sm font-medium">Go to dashboard</button>
      </div>
    </div>
  );
}
